import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppLinksService {

  private linkStore: string[] = [];
  public newLinkSubject: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  public appLinkCallback(url: string): void {
    console.log('App link service is getting the following link:', url);
    this.linkStore.push(url);
    this.newLinkSubject.next(true);
  }

  public getLinkThatContains(linkPart: string): string | undefined {
    const index = this.linkStore.findIndex(l => l.includes(linkPart));
    if (index === -1) { return undefined; }
    const ret = this.linkStore[index];
    this.linkStore.splice(index, 1);
    return ret;
  }
}
